import type { ApiTool } from '../state/aiApiTypes';

/** Who may invoke a toolset's tools. Mirrors MCPaaS `AccessScope`. */
export type ToolsetAccessScope = 'private' | 'organization' | 'public';

/**
 * A shared toolset (`organization` or `public`) delegates every attached tool's
 * Nexset to every permitted caller, so MCPaaS requires Nexset ADMIN on each one
 * before allowing it. A Marketplace grant writes `sharer`, which is enough to
 * *use* a Data Product but not to hand org-wide access to somebody else's — so
 * the server refuses with a 403 that reads like a permissions bug.
 *
 * Defaulting these toolsets to `private` keeps creation working and puts the
 * constraint where the user can see it. Nothing is lost: `private` is the
 * correct scope for a toolset built on a product you were granted, and the
 * owner can still widen it.
 */
export const containsMarketplaceTool = (tools: ApiTool[]): boolean =>
  tools.some((tool) => tool.access_mode === 'marketplace');

/** The scope to create a toolset with, given the tools attached to it. */
export const defaultAccessScopeFor = (tools: ApiTool[]): ToolsetAccessScope | undefined =>
  containsMarketplaceTool(tools) ? 'private' : undefined;
